import { IVerboseComponent } from 'interfaces/i-components';

export const verboseDebug = (props: IVerboseComponent, ...params: any[]) => {
  if (!props.verbose) {
    return;
  }

  console.debug(`${props.identifier} @ ${Date.now()}:`, ...params);
};
